type AzureDataStudioLogoProps = React.SVGProps<SVGSVGElement>

export const AzureDataStudioLogo = (props: AzureDataStudioLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    focusable="false"
    aria-label="Azure Data Studio icon"
    {...props}
  >
    <linearGradient id="azure_a" gradientUnits="userSpaceOnUse" x1="39.6553" x2="15.5519" y1="14.4104" y2="84.5183">
      <stop offset="0" stopColor="#114a8b" />
      <stop offset="1" stopColor="#0669bc" />
    </linearGradient>
    <linearGradient id="azure_b" gradientUnits="userSpaceOnUse" x1="47.6166" x2="42.1093" y1="47.1883" y2="49.0505">
      <stop offset="0" stopOpacity=".3" />
      <stop offset=".071" stopOpacity=".2" />
      <stop offset=".321" stopOpacity=".1" />
      <stop offset=".623" stopOpacity=".05" />
      <stop offset="1" stopOpacity="0" />
    </linearGradient>
    <linearGradient id="azure_c" gradientUnits="userSpaceOnUse" x1="44.4002" x2="70.6783" y1="12.358" y2="81.8589">
      <stop offset="0" stopColor="#3ccbf4" />
      <stop offset="1" stopColor="#2892df" />
    </linearGradient>
    <path
      d="m31.4288 9.00088h22.5712l-23.4311 70.51272c-.2409.7246-.6993 1.3542-1.3109 1.8002s-1.3456.686-2.0985.6862h-17.56596c-.57047.0001-1.13276-.1378-1.64035-.4023-.50759-.2644-.94589-.6478-1.27864-1.1185-.33275-.4706-.55038-1.015-.6349-1.588-.08451-.573-.03348-1.1583.14888-1.7073l21.83007-65.6966c.2407-.7249.6992-1.3548 1.311-1.80101s1.346-.68537 2.0992-.68541z"
      fill="url(#azure_a)"
    />
    <path
      d="m65.0494 56h-36.3645c-.3381-.0004-.6684.1022-.948.2944s-.4955.4651-.6195.7831c-.1241.3181-.1505.6665-.0759.9999.0746.3335.2467.6365.4941.8696l23.3669 22.0546c.6804.6418 1.5762.9986 2.5065.9984h20.591z"
      fill="#0078d4"
    />
    <path
      d="m31.8236 9.00003c-.7734-.00297-1.5275.24142-2.152.69746-.6246.45601-1.0871 1.09981-1.3197 1.83741l-22.13778 65.5891c-.19768.551-.25975 1.1415-.18094 1.7216s.29618 1.1326.6337 1.6109c.33753.4783.7853.8683 1.30542 1.137.52012.2686 1.0973.4081 1.68271.4065h18.30239c.6817-.1218 1.3188-.4223 1.8463-.8709s.9264-1.0292 1.1561-1.6825l4.4147-13.0105 15.7693 14.7081c.6608.5466 1.4898.8488 2.3473.8558h20.5089l-8.9949-25.7042-26.2214.0062 16.0484-47.30197z"
      fill="url(#azure_b)"
    />
    <path
      d="m60.7975 11.4829c-.2424-.7237-.7041-1.3526-1.32-1.79802-.6159-.44543-1.3551-.68497-2.1133-.68488h-25.3642c.7582.00004 1.4973.23964 2.1132.68505.6159.44545 1.0776 1.07415 1.3201 1.79785l22.0122 65.6993c.184.5491.2356 1.1344.1504 1.7076-.0851.5732-.3045 1.1177-.64 1.5885-.3355.4709-.7775.8544-1.2894 1.119s-1.079.4027-1.6543.4027h25.365c.5753-.0002 1.1423-.1383 1.6541-.403.5117-.2646.9536-.6482 1.289-1.119s.5547-1.0153.6398-1.5884.0335-1.1584-.1504-1.7074z"
      fill="url(#azure_c)"
    />
  </svg>
)

try{ AzureDataStudioLogo.displayName ||= 'AzureDataStudioLogo' } catch {}